import { render, staticRenderFns } from "./tmc-map.vue?vue&type=template&id=a04caf12&scoped=true"
import script from "./tmc-map.vue?vue&type=script&lang=js"
export * from "./tmc-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04caf12",
  null
  
)

export default component.exports